import {RoomClientState} from '../../../shared/scripts/RoomClientState.ts'
import {FriendStatusData, OnlineStatus} from '../../../../shared/friends/FriendTypes'
import {UIRoomFriendListController} from '../../../shared/scripts/ui_html/room/UIRoomFriendListController'
import {UIMMobileBottomDrawer} from './UIMMobileBottomDrawer'

export class UIMInviteFriendsBottomDrawer extends UIMMobileBottomDrawer {
    static friendList: FriendStatusData[] = []
    static roomState: RoomClientState | undefined
    static friendListController: UIRoomFriendListController | undefined

    constructor() {
        super({key: 'strings:roomPage.inviteFriends'})

        UIMInviteFriendsBottomDrawer.friendListController = new UIRoomFriendListController(this.content as HTMLDivElement, this.title, this.content as HTMLDivElement)
        UIMInviteFriendsBottomDrawer.friendListController.updateFriendsList(UIMInviteFriendsBottomDrawer.friendList)
        if(UIMInviteFriendsBottomDrawer.roomState) UIMInviteFriendsBottomDrawer.friendListController.updateRoomState(UIMInviteFriendsBottomDrawer.roomState)
    }

    static updateFriendList(friends: FriendStatusData[]) {
        this.friendList = friends
        if(!this.friendListController) return
        this.friendListController.updateFriendsList(friends)
    }

    static updateFriendOnlineStatus(friendData: FriendStatusData) {
        const friendIndex = this.friendList.findIndex((friend: FriendStatusData) => friend.userId === friendData.userId)
        if(friendIndex < 0) this.friendList.push(friendData)
        else this.friendList[friendIndex] = friendData

        this.friendList = this.friendList.filter((friend: FriendStatusData) => friend.onlineStatus != OnlineStatus.Offline)
        if(!this.friendListController) return
        this.friendListController.updateFriendsList(this.friendList)
    }

    static updateRoomState(roomState: RoomClientState) {
        this.roomState = roomState
        if(!this.friendListController) return
        this.friendListController.updateRoomState(roomState)
    }
}
